import { MenuItem } from "./menu.types";

export const menuItems2: MenuItem[] = [
  {
    id: 5,
    label: "Vehicle reports",
    icon: "las la-chart-bar",
    permissionId: 8,
    subItems: [
      { id: 6, label: "List reports", icon: "las la-minus", to: "/reports", permissionId: 8 },
      { id: 7, label: "New report", icon: "las la-minus", to: "/new-report", permissionId: 8 },
    ],
  },
  {
    id: 8,
    label: "Fleet reports",
    icon: "las la-users-cog",
    permissionId: 8,
    subItems: [
      { id: 9, label: "Fleet reports", icon: "las la-minus", to: "/fleet-reports", permissionId: 8 },
      { id: 10, label: "New report", icon: "las la-minus", to: "/new-fleet-report", permissionId: 8 },
    ],
  },
];
